import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import GS from '../grafsync/grafsync';
import ActionText from './ActionText';
import BasicChip from './BasicChip';
import Errored from './Errored';
import Loading from './Loading';
import { globalStyles as styles } from './style/gstheme';
import TitledPanel from './TitledPanel';
import { makeCancelable, sortObjects } from './utils/utils';
import Notification from './Notification';

class GroupPicker extends Component {

  constructor(props) {
    super(props);
    this.state = {
      groups: [],
      isLoadingGroups: true,
      isErrored: null
    };
    this.cancellable = null;
  }

  componentDidMount() {
    this.doGetGroups()
      .promise
      .then(data => {
        const sortedGroups = data ? sortObjects([...data], 'label') : null;
        this.setState({ groups: sortedGroups, isLoadingGroups: false });
        const isAdmin = sortedGroups.some(g => g.id === "https://graphifi.com/data/usergroup/admins");
        if (isAdmin) this.props.onSetAdmin();
      })
      .catch((e) => {
        if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
      });
  }

  doGetGroups() {
    this.cancellable = makeCancelable(GS.getManagedGroups(this.props.user));
    return this.cancellable;
  }

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
  }

  toggleGroup = (group) => {
    this.props.handleToggle(group, this.state.groups);
  };

  render() {

    const { groupList, adminIsEditable, isReadOnly, requiredViewEntitlement } = this.props;
    const { isLoadingGroups, groups, isErrored } = this.state;

    if (isErrored) return <Errored data={isErrored} />;
    if (isLoadingGroups) return <Loading />;
    if (!groups) return <ActionText>You are not allowed to alter the permissions.</ActionText>;

    const viewEntitlement = groups.some(g => g.id === "https://graphifi.com/data/usergroup/admins")
      ||
      groupList.some(gp => groups.find(ug => ug.id === gp).entitlement.includes(requiredViewEntitlement));

    return (
      <React.Fragment>
        {!viewEntitlement &&
          <Notification text="There is no assigned group that you are a member of that has viewing permissions for the project." dataTest="no-view-entitlement" />
        }
        <Grid
          container
          spacing={1}
          style={!adminIsEditable ?
            viewEntitlement ?
              { height: '100%' }
              :
              { height: 'calc(100% - 38px)' }
            :
            { height: '100%' }}>
          <Grid item xs={12} md={6}>
            <TitledPanel dataTest="available-groups" title="Available Groups" height="full">
              {groups
                .filter(group => !groupList.includes(group.id))
                .filter(group => !adminIsEditable && group.id === "https://graphifi.com/data/usergroup/admins" ? false : true)
                .map((group, index) =>
                  <BasicChip
                    key={"available-chip-" + index}
                    dataTest={"group-" + group.label["en"]}
                    onClick={!isReadOnly ? () => this.toggleGroup(group.id) : null}
                    label={group.label["en"]}
                  />
                )}
            </TitledPanel>
          </Grid>
          <Grid item xs={12} md={6}>
            <TitledPanel dataTest="assigned-groups" title="Assigned Groups" height="full">
              {groupList && groups
                .filter(group => groupList && groupList.includes(group.id))
                .filter(group => !adminIsEditable && group.id === "https://graphifi.com/data/usergroup/admins" ? false : true)
                .map((group, index) =>
                  <BasicChip key={"assigned-chip-" + index}
                    dataTest={"group-" + group.label["en"]}
                    onDelete={!isReadOnly ? () => this.toggleGroup(group.id) : null}
                    label={group.label["en"]}
                  />
                )}

            </TitledPanel>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

GroupPicker.defaultProps = {
  adminIsEditable: true,
  isReadOnly: false
};

GroupPicker.propTypes = {
  classes: PropTypes.object.isRequired,
  requiredViewEntitlement: PropTypes.string.isRequired,
  onSetAdmin: PropTypes.func.isRequired,
  handleToggle: PropTypes.func.isRequired,
  groupList: PropTypes.array.isRequired,
  isReadOnly: PropTypes.bool,
  adminIsEditable: PropTypes.bool
};

export default withStyles(styles)(GroupPicker);